/* Onegenz V50: route the floating CTA through the actual Shopify product form.
   Keep the theme's normal AJAX cart and variant validation intact. */
(function () {
  'use strict';
  function mainForm() {
    return document.querySelector('product-form[data-main="true"] form[data-type="add-to-cart-form"]') ||
      document.querySelector('product-form[data-main="true"] form[action*="/cart/add"]');
  }
  function notice(message) {
    var form = mainForm();
    if (!form) return;
    var wrapper = form.closest('product-form');
    var error = wrapper && wrapper.querySelector('.product-form__error-message');
    if (error) {
      error.textContent = message;
      var parent = error.closest('.product-form__error-message-wrapper');
      if (parent) parent.hidden = false;
    }
    wrapper && wrapper.scrollIntoView({behavior:'smooth',block:'center'});
  }
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var sticky = target.closest('sticky-atc, .sticky-atc');
    if (!sticky) return;
    var button = target.closest('button, [role="button"], a');
    if (!button || !sticky.contains(button)) return;
    /* Do not hijack close, variant pickers, quantity controls or navigation. */
    if (button.closest('.quantity, .product-form__input, select') ||
        button.matches('[name="minus"],[name="plus"],.sticky-atc__close') ||
        (button.matches('a') && button.getAttribute('href') && button.getAttribute('href') !== '#')) return;
    var label = (button.textContent || '').trim().toLowerCase();
    if (!button.matches('.button, .atc-button, [name="add"], [type="submit"]') &&
        !/add to cart|add to bag|choose options/i.test(label)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var form = mainForm();
    if (!form) { notice('Product form is unavailable. Please reload the page.'); return; }
    var submit = form.querySelector('button[type="submit"][name="add"], button.product-form__submit');
    var variant = form.querySelector('input[name="id"]');
    if (!variant || !variant.value) { notice('Please select a size before adding to cart.'); return; }
    if (!submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true') {
      notice('Please choose an available size before adding to cart.'); return;
    }
    /* Click the genuine product submit button, so Shopify/theme AJAX cart runs once. */
    submit.click();
  }, true);
})();
